export default __webpack_public_path__ + "static/media/iconobot.ef3ea482.svg";